// extracted by mini-css-extract-plugin
export default {"root":"Tiles_root__KNa1M","tile":"Tiles_tile__dLXFT"};